import React, { Suspense } from 'react';
import { useParams } from 'react-router-dom';
import Loader from '../components/Loader';

const EditBlogPost = React.lazy(() => import('../components/EditBlogPost'));
const EditPostView = React.lazy(() => import('../components/EditPostView'));

const EditBlogPostPage = () => {
  const { id } = useParams<{ id: string }>();
  const urlParams = new URLSearchParams(window.location.search);
  const mode = urlParams.get('mode') || 'edit'; // Default to 'edit' if not specified

  return (
    mode === 'view' ?
      <Suspense fallback={<Loader />}>
        <EditPostView postId={id || '0'} />
      </Suspense>
      :
      <Suspense fallback={<Loader />}>
        <EditBlogPost postId={id || '0'} />
      </Suspense>
  );
};

export default EditBlogPostPage;
